/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { ICON_DASHBOARD, NavigationItem } from '@squiz/sds';
import { PRODUCT_STRINGS } from 'apps/console-core/src/Constants/Strings.constants';
import React from 'react';
import { ConnectWorkspaces } from '../Screens/ConnectWorkspaces/ConnectWorkspaces';
import { Datastore } from '../Screens/Datastore/Datastore';
import { FormInstances } from '../Screens/FormInstances/FormInstances';
import { FunnelbackAdminInstances } from '../Screens/FunnelbackInstances/Administration/FunnelbackAdminInstances';
import { MatrixInstances } from '../Screens/MatrixInstances/MatrixInstances';
import { screenPaths } from './ScreenPaths.constants';
import { INSTANCE_MANAGEMENT_STRINGS } from './Strings.constants';

/**
 * Form instances screen.
 */
export const FORM_INSTANCES: NavigationItem = {
  devices: [],
  key: `forms`,
  label: INSTANCE_MANAGEMENT_STRINGS.advancedForms,
  path: screenPaths.advancedForms,
  screen: <FormInstances />,
};

/**
 * Connect workspaces screen.
 */
export const CONNECT_WORKSPACES: NavigationItem = {
  devices: [],
  key: `connect`,
  label: PRODUCT_STRINGS.connect,
  path: screenPaths.connectWorkspaces,
  screen: <ConnectWorkspaces />,
};

/**
 * Datastore landing screen.
 */
export const DATASTORE_LANDING: NavigationItem = {
  icon: ICON_DASHBOARD,
  key: `datastore`,
  label: INSTANCE_MANAGEMENT_STRINGS.dataServices,
  path: screenPaths.dataServices,
  screen: <Datastore />,
};

/**
 * Funnelback instances - administration screen.
 */
export const FUNNELBACK_ADMIN_INSTANCES: NavigationItem = {
  devices: [],
  key: `funnelback-search`,
  label: PRODUCT_STRINGS.funnelback,
  path: screenPaths.search,
  screen: <FunnelbackAdminInstances />,
};

/**
 * Matrix instances screen.
 */
export const MATRIX_INSTANCES: NavigationItem = {
  devices: [],
  key: `matrix`,
  label: PRODUCT_STRINGS.matrix,
  path: screenPaths.contentManagement,
  screen: <MatrixInstances />,
};
